import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateTRSCluster } from 'API/TRSCluster/updateTRSCluster';

const useUpdateTRSCluster = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const updateCluster = async (clusterData) => {
        try {
            const response = await updateTRSCluster(clusterData);
            return response.data;
        } catch (error) {
            console.error('Error updating TRS cluster:', error);
            throw error;
        }
    };

    return useMutation({
        mutationFn: updateCluster,
        onSuccess: (data, variables) => {
            // Invalidate and refetch the clusters list
            queryClient.invalidateQueries({ queryKey: ['TRSClusters'] });
            // Invalidate the specific cluster being edited
            queryClient.invalidateQueries({
                queryKey: ['TRSCluster', variables.id],
            });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useUpdateTRSCluster;
